import { LS_WIDGET_STATE_KEY } from '../constants';
import { initialState as stepsInitialState } from '../features/steps/stepsSlice';

const getLsWidgetState = (vehicleId = null, initialSteps = {}) => {
	if (window) {
		let lsWidgetState =
			JSON.parse(localStorage.getItem(LS_WIDGET_STATE_KEY)) || {};

		if (!lsWidgetState[vehicleId]) {
			lsWidgetState = { ...lsWidgetState, [vehicleId]: initialSteps };
		}

		return lsWidgetState;
	}
	return null;
};

export const getLsWidgetStateByVehicleId = (
	vehicleId = null,
	initialSteps = {}
) => {
	const lsWidgetState = getLsWidgetState(vehicleId, initialSteps);
	return lsWidgetState?.[vehicleId];
};

export const updateLsWidgetState = (vehicleId = null, steps = {}) => {
	if (window) {
		const lsWidgetState = getLsWidgetState(vehicleId, steps);
		const newWidgetState = {
			...lsWidgetState,
			[vehicleId]: {
				...steps
			}
		};
		localStorage.setItem(
			LS_WIDGET_STATE_KEY,
			JSON.stringify(newWidgetState)
		);
	}
};

/**
 * Migrate localStorage steps to add 'enabled' key (by Digital retailing data)
 * @param {Object} lsSteps - Steps from localStorage
 * @param {Object} serverSteps - Steps from server (with enabled flags)
 * @returns {Object} Migrated steps with enabled flags merged
 */
export const migrateLsStepsWithEnabledFlags = (lsSteps = {}, serverSteps = {}) => {
	const stepKeys = ['payment', 'tradeIn', 'protectionPlans', 'creditStatus', 'testDrive'];
	
	const migratedSteps = {};
	
	stepKeys.forEach(stepKey => {
		migratedSteps[stepKey] = {
			...stepsInitialState[stepKey], // Default values
			...lsSteps[stepKey], // Override with localStorage
			enabled: serverSteps[stepKey]?.enabled ?? true
		};
	});
	
	// Preserve dealXgId
	migratedSteps.dealXgId = lsSteps.dealXgId ?? null;
	
	return migratedSteps;
};
